module.exports = __webpack_public_path__ + "static/img/Kwai.1f9d136.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Kwai.jpg
// module id = 1ZYQ
// module chunks = 101